import EgwWebFont from "src/assets/EgwWebFont";
import { MENU_ITEM_LOCATION } from "@/shared/utils/menu";
import { EXTERNAL_URLS, URLS } from "@/shared/utils/url/url";
import { NEXT_URLS } from "./routes/routes.constants";

export const goToFullAppLabel = "goToFullApp";

export const MenuItems = {
  allCollection: {
    add_class: "all-collections",
    url: "/",
    id: "/",
    label: "allCollection",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  subscription: {
    add_class: "subscription",
    url: NEXT_URLS.subscription,
    id: NEXT_URLS.subscription,
    label: "subscriptions",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: true,
  },
  moreAboutUs: {
    add_class: "info",
    url: NEXT_URLS.about,
    id: NEXT_URLS.about,
    label: "whatIsEGW",
    locations: [
      MENU_ITEM_LOCATION.HOME,
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  about: {
    add_class: "biography",
    url: EXTERNAL_URLS.about,
    id: EXTERNAL_URLS.about,
    newTab: true,
    label: "aboutEW",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  donate: {
    add_class: "donate",
    url: EXTERNAL_URLS.donate,
    id: EXTERNAL_URLS.donate,
    newTab: true,
    label: "supportOur",
    locations: [
      MENU_ITEM_LOCATION.HOME,
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  faq: {
    add_class: "faq",
    url: EXTERNAL_URLS.faq,
    id: EXTERNAL_URLS.faq,
    newTab: true,
    label: "shortFaq",
    shortLabel: "shortFaq",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  bibliography: {
    icon: EgwWebFont["ABC"],
    label: "bibliography",
    url: URLS.bibliography,
    id: URLS.bibliography,
    locations: [
      MENU_ITEM_LOCATION.MENU,
    ],
  },
  contactUs: {
    add_class: "contact-us",
    url: NEXT_URLS.contactUs,
    id: NEXT_URLS.contactUs,
    label: "contactUs",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS,
      MENU_ITEM_LOCATION.MENU,
    ],
    onlyAuth: false,
  },
  goToFullApp: {
    id: "fullVersionLink",
    url: "fullVersionLink",
    newTab: false,
    icon: EgwWebFont["go-to-full-app"],
    label: goToFullAppLabel,
    locations: [MENU_ITEM_LOCATION.MENU],
    add_class: "goToFullApp"
  },
  settings: {
    add_class: "settings",
    label: "settings",
    id: NEXT_URLS.settings,
    url: NEXT_URLS.settings,
    onlyAuth: true,
    locations: [MENU_ITEM_LOCATION.BREADCRUMBS, MENU_ITEM_LOCATION.MENU]
  },
  login: {
    icon: EgwWebFont["profile"],
    label: "login",
    id: URLS.login,
    onlyNoAuth: true,
    locations: [MENU_ITEM_LOCATION.MENU]
  },
  logout: {
    icon: EgwWebFont["profile"],
    label: "logout",
    id: URLS.logout,
    onlyAuth: true,
    locations: [MENU_ITEM_LOCATION.MENU]
  },
  bibliographyEgw: {
    url: NEXT_URLS.bibliographyEgw,
    id: NEXT_URLS.bibliographyEgw,
    label: "egwBibliography",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS
    ],
    onlyAuth: false,
  },
  bibliographyBible: {
    url: NEXT_URLS.bibliographyBible,
    id: NEXT_URLS.bibliographyBible,
    label: "bibleBibliography",
    locations: [
      MENU_ITEM_LOCATION.BREADCRUMBS
    ],
    onlyAuth: false,
  },
  search: {
    url: NEXT_URLS.search,
    id: NEXT_URLS.search,
    label: "searchResults",
    locations: [],
    onlyAuth: false,
  },
  searchLocal: {
    url: NEXT_URLS.searchLocal,
    id: NEXT_URLS.searchLocal,
    label: "search",
    locations: [],
    onlyAuth: false,
  },
  privacyPolicy: {
    label: "privacyPolicy",
    id: URLS.privacyPolicy,
    locations: [],
  },
  copirightNotice: {
    label: "copirightNotice",
    id: URLS.copirightNotice,
    locations: [],
  },
  userAgreement: {
    label: "userAgreement",
    id: URLS.userAgreement,
    locations: [],
  },
  offline: {
    label: "books",
    id: URLS.offline,
    locations: [],
  },
};

export const MenuItemsList = Object.values(MenuItems);

export const MainMenuItem = {
  url: "/",
  id: "/",
  label: "main",
  children: MenuItemsList
};
